export default "__VITE_ASSET__p9EvnYC$__"